import { httpCreate } from './http';

const http = httpCreate('/srv/marketing-sms-config');

export const marketingSmsConfig = {
	// 根据直播间id获取短信通知配置
	getConfigByActivityId(params) {
		return http.get(``, { params });
	},
	// 导入手机号
	uploadNameListFileToActivity(params, body) {
		return http.post(`/upload`, body, { params });
	},
	// 测试发送短信
	sendPhoneNow(params) {
		return http.post(`/sendPhoneNow`, {}, { params });
	},
	save(body, params) {
		return http.post(`/save`, body, { params });
	},
	getSurveyList() {
		return http.get(`/surveyList`);
	},
};
